import { observer } from "./parts/observer.js";
import "./parts/analytics.js";
import "./parts/modals.js";

function initUnderlines() {
  const headings = document.querySelectorAll(
    ":is(h1, h2, h3, h4,h5,h6.wp-block-heading,.wp-block-paragraph):has(em)",
  );

  headings.forEach((heading) => {
    observer.observe(heading);
  });
}

function init() {
  initUnderlines();
}

document.addEventListener("DOMContentLoaded", init);
